import { useFieldArray, useFormContext } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { DataList } from "@/common/DataList";
import type { DataListProps } from "@/common/DataList/types";
import type { FC, ReactNode } from "react";
import type { PersonFormArrayKeys } from "../../types";
import type { ActivitiesTabFormValues } from "../../Tabs/ActivitiesTab/schemas";
import type { GeneralInfoTabFormValues } from "../../Tabs/GeneralInfoTab/schema";
import { contactsIsEditSelector, setContactsIsEdit } from "../../slice";

type PersonFormCompound = ActivitiesTabFormValues & GeneralInfoTabFormValues;

type FormField = PersonFormCompound[PersonFormArrayKeys][number];

export type FormContactDataListProps = {
  title: string;
  editNode: (index: number) => ReactNode;
  fieldArrayName: PersonFormArrayKeys;
  addableModel: FormField;
  valueDarkColor?: boolean;
  transformFieldToData: (field: any) => DataListProps["data"][number];
};
export const FormContactsDataList: FC<FormContactDataListProps> = ({
  fieldArrayName,
  title,
  editNode,
  transformFieldToData,
  valueDarkColor,
  addableModel,
}) => {
  const { control } = useFormContext<PersonFormCompound>();
  const dispatch = useAppDispatch();
  const isEdit = useAppSelector(contactsIsEditSelector);
  const { append, fields, remove } = useFieldArray({
    control,
    name: fieldArrayName,
  });
  const addHandler = () => {
    dispatch(setContactsIsEdit(true));
    append(addableModel);
  };
  const baseData = fields.map(transformFieldToData);
  return (
    <DataList
      data={valueDarkColor ? baseData.map((item) => ({ ...item, valueDarkColor: true })) : baseData}
      onAddClick={addHandler}
      onTrashClick={remove}
      isEdit={isEdit}
      title={title}
      editNode={editNode}
    />
  );
};
